import { Navigate } from '@tanstack/react-router'

import { resolveUnknownRouteEntryPath } from '@/lib/auth/portal-routes'

export function UnknownRouteRedirect() {
  return <Navigate replace to={resolveUnknownRouteEntryPath(window.location.pathname)} />
}
